import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { TdsMerchant } from '@root/globalTypes';

type GetTdsMerchantsReturn = {
  data: TdsMerchant[];
  isPending: boolean;
};

export function useList(): GetTdsMerchantsReturn {
  const { query } = useApi();

  const { data, isPending } = useQuery<{ tdsMerchants: TdsMerchant[] }>({
    queryKey: queryKeys.tdsMerchants,
    queryFn: (): Promise<{ tdsMerchants: TdsMerchant[] }> =>
      query({
        path: 'v1/staff/tds_merchants',
      }),
  });

  return {
    data: data?.tdsMerchants || [],
    isPending,
  };
}
